import { render } from "./CarbonFootprint.vue?vue&type=template&id=20c85372"
import script from "./CarbonFootprint.vue?vue&type=script&lang=js"
export * from "./CarbonFootprint.vue?vue&type=script&lang=js"

import "./CarbonFootprint.vue?vue&type=style&index=0&id=20c85372&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__